export default "__VITE_ASSET__93b92e05__"